// extracted by mini-css-extract-plugin
export default {"textarea-wrapper":"ReasonStep_textarea-wrapper__aMHNP"};